import React, {useState} from 'react'
import { MdKeyboardArrowDown } from 'react-icons/md'

const ABC = [
  {
    ABCD: 'Abatar',
    EFGH:'sci-fi'
  },
  {
    ABCD: 'Titanic',
    EFGH:'drama'
  },
  {
    ABCD: 'Star Wars: The Force Awakens',
    EFGH:'sci-fi'
  }
]
function DEF(ABC,y) {
  return ABC.filter(x => 
    x.EFGH.toLowerCase().includes(y.toLowerCase())
  )
}
const GHI = ({x}) => {
  return (<div className='text-xs'>{x.ABCD}<br/></div>)
}
const VWX = x => {
  let map = new Map()
  x.forEach(x2 => map.set(x2.EFGH, x2.EFGH))
  return [...map.values()]
}
export default function ABCD() {
  const [JKL, setJKL] = useState(ABC)
  const [MNO, setMNO] = useState('')
  const [PQR, setPQR] = useState(false)
  const STU = (x) => {
    setMNO(x)
    const result = DEF(ABC, x)
    setJKL(result)
    setPQR(!PQR)
  }
  return (
    <>
    <div className='text-xs'>
      Genre:
      <div className='flex border border-gray-800 w-[100px] justify-between' onClick={()=>setPQR(!PQR)}>{MNO==''?'Select':<>{MNO}</>}<MdKeyboardArrowDown className='mt-auto'/></div>
      {!PQR?'':<div className='border border-gray-800 border-t-[0px] w-[100px]'>{VWX(ABC).map(x=>
      <div 
        value={x} 
        className='hover:bg-gray-200'
        onClick={()=>STU(x)}>{x}</div>
      )}</div>}
      {
        JKL.map(x => <GHI x={x}/>)
      }
  </div>
    </>
  )
}
